import { createStyles, makeStyles } from '@forgeglobal/design-framework';

export const useStyles = makeStyles((theme) =>
  createStyles({
    banner: {
      marginBottom: theme.spacing(5),
    },
    form: {
      width: '100%',
    },
    container: {
      maxWidth: 560,
      width: '100%',
      margin: '0 auto',
    },
    title: {
      marginBottom: theme.spacing(6),
      [theme.breakpoints.down('md')]: {
        marginBottom: theme.spacing(4),
      },
    },
    fields: {
      marginBottom: theme.spacing(10),
      [theme.breakpoints.down('md')]: {
        marginBottom: theme.spacing(6),
      },
    },
    field: {
      marginBottom: theme.spacing(3),
    },
    fail: {
      paddingLeft: theme.spacing(3.3),
      marginBottom: theme.spacing(4),
    },
    textField: {
      '&.MuiSvgIcon-colorAction, .MuiSvgIcon-colorAction': {
        display: 'none',
      },
    },
    buttonsContainer: {
      display: 'flex',
      justifyContent: 'flex-end',
    },
    primaryButton: {
      marginLeft: theme.spacing(2),
    },
  })
);
